import * as React from "react";

function SvgBraze(props, ref) {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 256 256"
      xmlns="http://www.w3.org/2000/svg"
      preserveAspectRatio="xMidYMid"
      {...{ ...props, ref }}
    >
      <path
        d="M115.665 146.618c2.095-20.014 14.662-36.305 29.324-36.305s22.575 16.29 20.48 36.305c-2.094 20.015-14.196 36.538-27.927 36.538s-24.902-12.567-21.877-36.538M128 237.382a109.15 109.15 0 01-84.247-39.564c18.152 5.818 38.4.698 54.225-14.894a52.13 52.13 0 004.655-5.353c7.214 15.593 21.178 23.505 35.142 23.505 23.738 0 43.752-24.436 46.08-54.69 2.327-30.255-14.662-54.226-37.237-54.226a43.985 43.985 0 00-23.273 6.284l6.982-40.728c.696-3.26-.069-6.661-2.094-9.309-2.095-3.258-3.957-4.654-6.75-4.654H88.903a3.956 3.956 0 00-3.724 3.49 93.09 93.09 0 00-1.862 11.637c-.232 2.56 1.63 3.49 3.724 3.49h23.738c-3.723 23.274-11.17 68.423-13.265 79.826a57.484 57.484 0 01-15.128 28.626c-13.032 13.033-37.003 16.058-51.2 1.862-4.887-5.12-12.567-17.688-12.567-44.684C18.618 67.59 67.59 18.618 128 18.618c60.41 0 109.382 48.972 109.382 109.382 0 60.41-48.972 109.382-109.382 109.382M128 0C57.308 0 0 57.308 0 128c0 70.692 57.308 128 128 128 70.692 0 128-57.308 128-128A128 128 0 00128 0"
        fill="currentColor"
      />
    </svg>
  );
}

export default React.forwardRef(SvgBraze);
